/*
* @Des 组件 历史轨迹
* @Description
* @Author
* @Date 2021/8/17
*/
<template>
	<div class="view-tree-table">
		<!-- router-title-box start -->
		<div class="router-title-box" >
			<div class="router-title-item">
				<a href="javascript:void(0);" class="router-title-back cursor-pointer" @click="closeRouter" title="返回首页"></a>
				<div class="router-title-tit">历史轨迹</div>
			</div>
		</div>
		<!-- router-title-box end -->
		
		<LocationTrackTable ref="locationTrackTable" />
    </div>
</template>

<script>
	// 引入组件 轨迹数据
	import LocationTrackTable from '@/components_pages/Location/LocationTrackTable'

	export default {
		/**
		 * @Des 组件名称
		 * @Auth
		 * @Date 2021/8/17
		 */
		name: 'LocationTrack',
		/**
		 * @Des 组件注册
		 * @Auth
		 * @Date 2021/8/17
		 */
		components: {
			// 组件 轨迹数据
			LocationTrackTable,
		},
		/**
		 * @Des 接收数据
		 * @Auth
		 * @Date 2021/8/17
		 */
		props: {

		},

		/**
		 * @Des 加载执行 pre
		 * @Auth
		 * @Date 2021/8/17
		 */
		created() {
			// 开启订阅消息
			// this.startSubscribes();
		},
		/**
		 * @Des 加载完成执行
		 * @Auth
		 * @Date 2021/8/17
		 */
		mounted() {

		},
		/**
		 * @Des 销毁之前执行
		 * @Auth
		 * @Date 2021/8/17
		 */
		beforeDestroy() {
			// 取消订阅消息
			// this.endSubscribes();
		},

		/**
		 * @Des 数据模型
		 * @Auth
		 * @Date 2021/8/17
		 */
		data() {
			return {
				// 当前选中 标签
				activeName: 'first',
				/**
				 * @Des 轨迹数据
				 * @Auth
				 * @Date 2021/8/17
				 */
				trackInfo: {},
			}
		},
		/**
		 * @Des 方法
		 * @Auth
		 * @Date 2021/8/17
		 */
		methods: {
            /**
             * @Des 关闭路由
             * @Auth
             * @Date
             */
            closeRouter () {
              // 路由 子模块 name
              this.routerSubName = '';
              // 跳转到 首页
              this.$router.replace({path: this.$store.state.homePage}, ()=>{}, ()=>{});
            },// closeRouter

            /**
             * @Des 点击tab标签(之前)
             * @Auth
             * @Date 2021/8/17
             */
            beforeHandle(tab, event){
            },

			//========================== 订阅消息 start ==========================
			/**
			 * @Des 开启订阅消息
			 * @Auth
			 * @Date 2021/8/21
			 */
			startSubscribes() {
				// 订阅消息 人员轨迹数据
				/*this.sub_trackInfo = this.$pubsub.subscribe('trackInfo', (name, data) => {
					// 轨迹数据
					this.trackInfo = Object.assign({}, data);
				});*/
			},
			/**
			 * @Des 取消订阅消息
			 * @Auth
			 * @Date 2021/8/21
			 */
			endSubscribes() {
				//取消订阅 相关信息
				// this.$pubsub.unsubscribe(this.sub_trackInfo);
			},
			//========================== 订阅消息 end ==========================
			
		},// methods

	}// export default
</script>

/* CSS */
<style lang="scss" scoped>


</style>



// WEBPACK FOOTER //
// src/views/system-manager/location/LocationTrack.vue